<div class="c-form--d c-form__section d-flex">
  <span class="fw-bold mr-10" i18n="@@common.add_fields">Add Fields</span>
  <div class="p500-ui-form-field mr-10">
    <span
      role="button"
      class="p500-ui-form-field__hint"
      p500UITooltip
      i18n-tooltipData="@@common.click_for_description"
      tooltipData="Click for description"
      (click)="openHintModal()"
      >?</span
    >
  </div>
  <button p500-ui-circled-button size="small" color="primary" type="button" (click)="addForm()" [disabled]="isDisabled">
    <p500-ui-icon name="plus"></p500-ui-icon>
  </button>
</div>
<ng-container *ngFor="let group of form.controls; index as i">
  <ng-container [formGroup]="group">
    <div class="row">
      <div class="c-form__section col-5">
        <p500-ui-select-field
          formControlName="goal_type"
          i18n-label="@@common.goal_type"
          label="Goal Type"
          [data]="globalData.goal_types"
          i18n-hint="@@baseline.goal_type_tooltip"
          hint="For correct functioning, Goal Types must be different"
        ></p500-ui-select-field>
      </div>
      <div class="c-form__section col-6">
        <p500-ui-select-field
          formControlName="baseline_field"
          i18n-label="@@common.baseline_field"
          label="Baseline Field"
          class="flex-1"
          [data]="globalData.baseline_fields"
          i18n-hint="@@baseline.must_natch_tooltip"
          hint="For correct functioning, Baseline Fields must match"
        ></p500-ui-select-field>
      </div>
      <div class="c-form__section col-1">
        <div class="d-flex flex-column justify-content-end h100">
          <button p500-ui-circled-button size="small" type="button" color="warn" class="mb-6" [transparent]="true" (click)="removeForm(i)">
            <p500-ui-icon name="close"></p500-ui-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
